module.exports = __webpack_public_path__ + "static/media/logo-s4s-on.8ee19370.svg";